// import { contract_address } from "config";
// import { contract_abi } from "config";
// import React, { useEffect, useState } from "react";
// import { NotificationManager } from "react-notifications";
// import { useSelector } from "react-redux";
// import Web3 from "web3";
// import {
//   getInfoStaking,
//   staking,
//   getInfoUser,
//   addTree,
//   checkApproveStaking,
//   submitApproveStaking,
//   unStaking,
//   withdraw
// } from "service";
// import Countdown from 'react-countdown';



// const LoadingButton = ({ className }) => {
//   return (
//     <button className={className}>
//       <div className="spinner-border spinner-border-sm" role="status">
//         <span className="sr-only">Loading...</span>
//       </div>
//     </button>
//   );
// };

// const Bridge = (props) => {
//   const state = useSelector((state) => state);
//   const [loading, setLoading] = useState(false);
//   const [profit, setProfit] = useState(0);
//   const [approve, setApprove] = useState(false);
//   const [packageStaking, setPackageStaking] = useState({});
//   const [BNB, setBNB] = useState(0);
//   const [SFT, setSFT] = useState(0);
//   const [balance, setBalance] = useState(0);
//   const [countdownKey, setCountdownKey] = useState(0);

//   const [price, setPrice] = useState({
//     symbolPrice: 0,
//     priceSFT: 0,
//     priceBNB: 0,
//     bnb: 0,
//   });

//   useEffect(() => {
//     getData();
//     setInterval(() => {
//       getData();
//     }, 1000);
//   }, []);

//   useEffect(() => {
//   }, [state.user]);

//   const getData = async () => {
//     const infoStaking = await getInfoStaking();
//     const checkApp = await checkApproveStaking();
//     if (!infoStaking) {
//       return
//     }
//     let { timeClaim, sttReceive, _stake } = infoStaking;

//     setApprove(checkApp.stt);
//     setBalance(checkApp.balance);
//     let obj = {};

//     obj.timeClaim = timeClaim;
//     obj.sttReceive = sttReceive;
//     obj.amount = Number(_stake.amount) / 1e18;
//     obj.received = Number(_stake.received) / 1e18;
//     obj.timestamp = Number(_stake.timestamp);
//     obj.pt = Number(_stake.pt);
//     let times = Math.floor(Date.now() / 1000) - obj.timestamp;
//     obj.profit = (obj.amount * times * obj.pt / 259200000) - obj.received;
//     if (obj.amount == 0) {
//       obj.pt = 0
//     }
//     // console.log(obj, checkApp);
//     setPackageStaking(obj)
//   };


//   const onConfirmSFT = async () => {
//     setLoading(true);
//     let data = await staking(SFT);
//     // console.log(data);
//     if (!data) {
//       NotificationManager.error("Error", "Error", 10000);
//     } else {
//       NotificationManager.success("Investment Success", "Success", 10000);
//     }
//     setLoading(false);
//     getData();
//   }

//   const _approve = async () => {
//     setLoading(true);
//     let data = await submitApproveStaking();
//     // console.log(data);
//     if (!data) {

//     }

//     setLoading(false);
//     getData();
//   }

//   const onClaim = async () => {
//     setLoading(true);
//     let data = await withdraw();
//     console.log(data);
//     if (!data) {
//       NotificationManager.error("Error", "Error", 10000);
//     } else {
//       NotificationManager.success("Withdraw Success", "Success", 10000);
//     }

//     setLoading(false);
//     getData();
//   }

//   const _unStaking = async () => {
//     // window.location.replace('/info')
//     setLoading(true);
//     let data = await unStaking();
//     console.log(data);
//     if (!data) {
//       NotificationManager.error("Error", "Error", 10000);
//     } else {
//       NotificationManager.success("Success", "Error", 10000);
//     }

//     setLoading(false);
//     getData();
//   }

//   useEffect(() => {
//     // Xử lý khi giá trị timeClaim thay đổi
//     if (packageStaking.timeClaim) {
//       // Tăng giá trị countdownKey để kích hoạt việc render lại Countdown component
//       setCountdownKey(prevKey => prevKey + 1);
//     }
//   }, [packageStaking.timeClaim]);

//   const max = () => {
//     console.log(balance);
//     setSFT(balance)
//   }

//   return (
//     <div className="site-main-content__buy-sft">
//       <div className="container">
//         <div className="manage-your-token-title">
//           <h3 className="main-title">Staking</h3>
//         </div>
//         <div className="row">
//           <div className="col col-12 col-sm-6">
//             <div className="block-item item-swap-rates">
//               <div className="block-item__wrap">
//                 <div className="block-item__content">
//                   <div className="buy-sft">
//                     <div className="row">
//                       <p>Balance LPs: {balance.toFixed(2)}</p>
//                       <div className="buy-sft-field col col-12">
//                         <input
//                           type="text"
//                           className="form-control"
//                           placeholder="0"
//                           onChange={(e) => {
//                             setSFT(Number(e.target.value));
//                           }}
//                           value={SFT}
//                         />
//                         <span onClick={max} style={{ cursor: 'pointer' }} className="unit">Max</span>
//                       </div>
//                     </div>
//                     {
//                       approve ? <div className="buy-sft-action text-center">
//                         {loading ? (
//                           <LoadingButton className="btn btn-primary" />
//                         ) : (
//                           <button
//                             className="btn btn-primary"
//                             onClick={onConfirmSFT}
//                           >
//                             Investment
//                           </button>
//                         )}
//                       </div>
//                         :
//                         < div className="buy-sft-action text-center">
//                           {loading ? (
//                             <LoadingButton className="btn btn-primary" />
//                           ) : (
//                             <button
//                               className="btn btn-primary"
//                               onClick={_approve}
//                             >
//                               Approve
//                             </button>
//                           )}
//                         </div>
//                     }
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col col-12 col-sm-6">
//             <div className="block-item item-swap-rates">
//               <div className="block-item__wrap">
//                 <div className="block-item__content">
//                   <div className="buy-sft">
//                     <div className="row">
//                       <div className="mb-4">Note: </div>
//                       {/* <p>* All profits are accumulated in the Info section.</p> */}
//                       {/* <p>* Please long Claim before using this function!</p> */}
//                       <p>* Please long Claim before using this function!</p>
//                     </div>
//                     <div className="buy-sft-action text-center">
//                       {loading ? (
//                         <LoadingButton className="btn btn-primary" />
//                       ) : (
//                         <button
//                           className="btn btn-primary"
//                           onClick={() => {
//                             _unStaking();
//                           }}
//                         >
//                           Un Stake
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div >
//   );
// };

// export default Bridge;



import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
const USDT_ABI = { "entrys": [{ "inputs": [{ "name": "add", "type": "address" }], "name": "changeAddressBurn", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "string" }], "constant": true, "name": "name", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "bool" }], "inputs": [{ "name": "spender", "type": "address" }, { "name": "value", "type": "uint256" }], "name": "approve", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "totalSupply", "stateMutability": "View", "type": "Function" }, { "name": "activateAntiBot", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "add", "type": "address" }], "name": "changeAddressTreasury", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "address" }], "constant": true, "name": "sunswapV2Pair", "stateMutability": "View", "type": "Function" }, { "inputs": [{ "name": "account", "type": "address" }], "name": "removeFromAdminlist", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "bool" }], "inputs": [{ "name": "sender", "type": "address" }, { "name": "recipient", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "transferFrom", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint8" }], "constant": true, "name": "decimals", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "bool" }], "inputs": [{ "name": "spender", "type": "address" }, { "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "account", "type": "address" }], "name": "addToBlacklist", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "account", "type": "address" }], "name": "removeFromBlacklist", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "changeBurnRate", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "sellFeeRate", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "buyFeeRate", "stateMutability": "View", "type": "Function" }, { "inputs": [{ "name": "add", "type": "address" }], "name": "changePair", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "inputs": [{ "name": "account", "type": "address" }], "name": "balanceOf", "stateMutability": "View", "type": "Function" }, { "inputs": [{ "name": "token_address", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "withdrawBUSDForOwner", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "changePercentAmountWhale", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "antiBot", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "address" }], "inputs": [{ "name": "factory", "type": "address" }, { "name": "token", "type": "address" }], "name": "createNewPair", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "transferRate", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "bool" }], "constant": true, "inputs": [{ "name": "account", "type": "address" }], "name": "checkAdmin", "stateMutability": "View", "type": "Function" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "changeBuyFeeRate", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "string" }], "constant": true, "name": "symbol", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "bool" }], "inputs": [{ "name": "spender", "type": "address" }, { "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "bool" }], "inputs": [{ "name": "recipient", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "transfer", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "changeSellFeeRate", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "bool" }], "constant": true, "name": "checkAntiBot", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "burnRate", "stateMutability": "View", "type": "Function" }, { "inputs": [{ "name": "add", "type": "address" }], "name": "changeAddressReceiver", "stateMutability": "Nonpayable", "type": "Function" }, { "name": "deactivateAntiBot", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "changeTransferRate", "stateMutability": "Nonpayable", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "inputs": [{ "name": "owner", "type": "address" }, { "name": "spender", "type": "address" }], "name": "allowance", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "uint256" }], "constant": true, "name": "treasuryRate", "stateMutability": "View", "type": "Function" }, { "outputs": [{ "type": "bool" }], "constant": true, "inputs": [{ "name": "account", "type": "address" }], "name": "checkBlackList", "stateMutability": "View", "type": "Function" }, { "inputs": [{ "name": "amount", "type": "uint256" }], "name": "withdrawTokenForOwner", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "account", "type": "address" }], "name": "addToAdminlist", "stateMutability": "Nonpayable", "type": "Function" }, { "inputs": [{ "name": "_addressReceiver", "type": "address" }, { "name": "_factory", "type": "address" }, { "name": "_lumiToken", "type": "address" }], "stateMutability": "Nonpayable", "type": "Constructor" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "ChangeBuyFeeRate", "type": "Event" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "ChangeSellFeeRate", "type": "Event" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "ChangeBurnRate", "type": "Event" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "ChangeTransferRate", "type": "Event" }, { "inputs": [{ "name": "rate", "type": "uint256" }], "name": "ChangePercentAmountWhale", "type": "Event" }, { "inputs": [{ "name": "status", "type": "uint256" }], "name": "ActivateAntiBot", "type": "Event" }, { "inputs": [{ "name": "status", "type": "uint256" }], "name": "DeactivateAntiBot", "type": "Event" }, { "inputs": [{ "name": "account", "type": "address" }], "name": "AddedAdmin", "type": "Event" }, { "inputs": [{ "name": "accounts", "type": "address[]" }], "name": "AddedBatchAdmin", "type": "Event" }, { "inputs": [{ "name": "account", "type": "address" }], "name": "RemovedAdmin", "type": "Event" }, { "inputs": [{ "name": "sender", "type": "address" }, { "name": "recipient", "type": "address" }, { "name": "amount", "type": "uint256" }], "name": "TransferStatus", "type": "Event" }, { "inputs": [{ "name": "amount", "type": "uint256" }], "name": "WithDraw", "type": "Event" }, { "inputs": [{ "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "to", "type": "address" }, { "name": "value", "type": "uint256" }], "name": "Transfer", "type": "Event" }, { "inputs": [{ "indexed": true, "name": "owner", "type": "address" }, { "indexed": true, "name": "spender", "type": "address" }, { "name": "value", "type": "uint256" }], "name": "Approval", "type": "Event" }] };
const USDT_ADDRESS = "TCxMi7iEVoDEoGd8DFVvZVh3mh9xWHrHAp";
const BRIDGE_ADDRESS = "TQUC4ZETdZxxmB74deofLXRKH63PuFa94i";

const LoadingButton = ({ className }) => {
  return (
    <button className={className}>
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </button>
  );
};

const Bridge = () => {
  // const [tronWeb, setTronWeb] = useState(null);
  const state = useSelector((state) => state);
  const [account, setAccount] = useState("");
  const [to, setTo] = useState("");
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [approvedAmount, setApprovedAmount] = useState(0);
  const [approvalAmount, setApprovalAmount] = useState("");
  const [connected, setConnected] = useState(true);
  const [SFT, setSFT] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    var obj = setInterval(async () => {
      var tronweb = window.tronWeb;
      if (tronweb && tronweb.defaultAddress.base58) {
        console.log(tronweb.defaultAddress.base58);
        // setTronWeb(tronweb);
        setAccount(tronweb.defaultAddress.base58);
        getUSDTBalance(tronweb.defaultAddress.base58);
        getApprovedAmount(tronweb.defaultAddress.base58);
        setConnected(true);
        clearInterval(obj)
        // var tx = await tronweb.transactionBuilder.sendTrx('TN9RRaXkCFtTXRso2GdTZxSxxwufzxLQPP', 10, 'TTSFjEG3Lu9WkHdp4JrWYhbGP6K1REqnGQ')
        // var signedTx = await tronweb.trx.sign(tx)
        // var broastTx = await tronweb.trx.sendRawTransaction(signedTx)
      } else {
        console.log('none wl');
      }
    }, 1000)
  }, []);

  useEffect(() => {
    if (state.address_web3) {
      setTo(state.address_web3);
    }
  }, [state.address_web3]);


  const getUSDTBalance = async (account) => {
    try {
      const usdtContract = await window.tronWeb.contract().at(USDT_ADDRESS);
      const balance = await usdtContract.balanceOf(account).call();
      setUsdtBalance(window.tronWeb.fromSun(balance));
    } catch (error) {
      console.error(" USDT:", error);
    }
  };

  const getApprovedAmount = async (account) => {
    try {
      const usdtContract = await window.tronWeb.contract().at(USDT_ADDRESS);
      const approvedAmount = await usdtContract.allowance(account, "TQUC4ZETdZxxmB74deofLXRKH63PuFa94i").call();
      console.log(window.tronWeb.fromSun(approvedAmount));
      setApprovedAmount(window.tronWeb.fromSun(approvedAmount));
    } catch (error) {
      console.error("approve:", error);
    }
  };

  const handleApprove = async () => {
    setLoading(true)
    try {
      const usdtContract = await window.tronWeb.contract().at(USDT_ADDRESS);
      const amount = window.tronWeb.toSun(usdtBalance);
      const tx = await usdtContract.approve("TQUC4ZETdZxxmB74deofLXRKH63PuFa94i", amount).send();
      console.log(":", tx);
      getApprovedAmount(account);
    } catch (error) {
      console.error("approve:", error);
    }
  };

  const bridgefc = async () => {
    setLoading(true)
    try {
      const usdtContract = await window.tronWeb.contract().at(BRIDGE_ADDRESS);
      const amount = window.tronWeb.toSun(SFT);
      console.log(amount, window.tronWeb.address.fromHex(to.replace("0x", "41")));
      const tx = await usdtContract.deposit(amount, window.tronWeb.address.fromHex(to.replace("0x", "41"))).send();
      // console.log(":", tx);
      setAccount(account);
      getUSDTBalance(account);
      getApprovedAmount(account);
    } catch (error) {
      console.error("approve:", error);
    }
    setLoading(false)
  };

  const max = () => {
    // console.log(usdtBalance);
    setSFT(usdtBalance)
  }

  // return (
  //   <div>
  //     {connected ? (
  //       <div>
  //         <h1>Thông tin tài khoản</h1>
  //         <p>Tài khoản: {account}</p>
  //         <p>Số dư USDT: {usdtBalance}</p>
  //         <p>Số tiền đã approve: {approvedAmount}</p>
  //         <div>
  //           <h2>Thực hiện approve</h2>
  //           <input
  //             type="text"
  //             value={approvalAmount}
  //             onChange={(e) => setApprovalAmount(e.target.value)}
  //             placeholder="Nhập số lượng token cần approve"
  //           />
  //           <button onClick={handleApprove}>Approve</button>
  //         </div>
  //       </div>
  //     ) : (
  //       <p>Yêu cầu kết nối ví</p>
  //     )}
  //   </div>
  // );

  return (
    <div className="site-main-content__buy-sft">
      <div className="container">
        <div className="manage-your-token-title">
          <h3 className="main-title">Bridge</h3>
        </div>
        <div className="row">
          <div className="col col-12 col-sm-6">
            <div className="block-item item-swap-rates">
              <div className="block-item__wrap">
                <div className="block-item__content">
                  <div className="buy-sft">
                    <div className="row">
                      <p>Tron Address: {account}</p>
                      <p>Balance GU: {usdtBalance}</p>
                      <div className="buy-sft-field col col-12 mb-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="0"
                          onChange={(e) => {
                            setSFT(Number(e.target.value));
                          }}
                          value={SFT}
                        />
                        <span onClick={max} style={{ cursor: 'pointer' }} className="unit">Max</span>
                      </div>
                      <p className="m-0">To (Bep20)</p>
                      <div className="buy-sft-field mt-2 col col-12">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="0"
                          onChange={(e) => {
                            setTo(e.target.value);
                          }}
                          value={to}
                        />
                      </div>
                    </div>
                    {
                      approvedAmount * 1 >= SFT * 1 ? <div className="buy-sft-action text-center">
                        {loading ? (
                          <LoadingButton className="btn btn-primary" />
                        ) : (
                          <button
                            className="btn btn-primary"
                            onClick={bridgefc}
                          >
                            Confirm
                          </button>
                        )}
                      </div>
                        :
                        < div className="buy-sft-action text-center">
                          {loading ? (
                            <LoadingButton className="btn btn-primary" />
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={handleApprove}
                            >
                              Approve
                            </button>
                          )}
                        </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );

}

export default Bridge;
